<template>
    <div class="block-editor send-waba-template-message">
        <a-spin class="spinner" :spinning="loading">
            <div class="editor-row">
                <div class="editor-row-title">{{ $t('auto.sendWhatsappTemplateMessageSonuGeleneKadarBekle') }}</div>
                <a-switch v-model="clone.waitForResponse" />
            </div>
            <div class="editor-row" v-if="clone.waitForResponse">
                <div class="editor-row-title">{{ $t('auto.sendWhatsappTemplateMessageBeklemeSResiSaniye') }}</div>
                <a-input-number v-model="clone.waitTime" :min="30" :max="600" />
            </div>
            <div class="editor-row">
                <div class="editor-row-title">{{ $t('auto.sendWhatsappTemplateMessageChannel') }}</div>
                <a-select class="classic-new-select" :placeholder="$t('auto.sendWhatsappTemplateMessageWhatsappBusinessChannel')" v-model="clone.channelId">
                    <a-select-option v-for="channel in businessChannels" :key="channel._id" :value="channel._id">
                        {{ channel.name }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="editor-row mmlite-block-row" v-if="isSupsisWabaChannel && isMmliteSendChoiceAvailable">
                <div class="mmlite-broadcast-block mmlite-broadcast-block--compact">
                    <div class="mmlite-broadcast-header">
                        <h4 class="mmlite-broadcast-heading">{{ $t("whatsapp_business_api.mmLiteBlockSectionTitle") }}</h4>
                    </div>
                    <div class="mmlite-broadcast-cards" role="radiogroup" :aria-label="$t('whatsapp_business_api.mmLiteBlockSectionTitle')">
                        <button
                            type="button"
                            class="mmlite-broadcast-card mmlite-broadcast-card--with-badge"
                            :class="{ 'mmlite-broadcast-card--active': clone.sendTemplateViaMmlite !== false }"
                            @click="clone.sendTemplateViaMmlite = true"
                        >
                            <span class="mmlite-broadcast-card-badge">{{ $t("whatsapp_business_api.mmLiteBroadcastBadgeRecommended") }}</span>
                            <span class="mmlite-broadcast-card-title">{{ $t("whatsapp_business_api.mmLiteBroadcastOptionRecommendedTitle") }}</span>
                            <span class="mmlite-broadcast-card-text">{{ $t("whatsapp_business_api.mmLiteBroadcastOptionRecommendedBody") }}</span>
                        </button>
                        <button
                            type="button"
                            class="mmlite-broadcast-card"
                            :class="{ 'mmlite-broadcast-card--active': clone.sendTemplateViaMmlite === false }"
                            @click="clone.sendTemplateViaMmlite = false"
                        >
                            <span class="mmlite-broadcast-card-title">{{ $t("whatsapp_business_api.mmLiteBroadcastOptionStandardTitle") }}</span>
                            <span class="mmlite-broadcast-card-text">{{ $t("whatsapp_business_api.mmLiteBroadcastOptionStandardBody") }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="editor-row" v-if="isSupsisWabaChannel && !isMmliteSendChoiceAvailable">
                <div class="editor-hint mmlite-hint mmlite-block-not-onboarded">{{ $t("whatsapp_business_api.mmLiteBlockNotOnboardedHint") }}</div>
            </div>
            <div class="editor-row" v-if="clone.channelId">
                <div class="editor-row-title">
                    {{ $t('auto.sendWhatsappTemplateMessageTemplate') }}
                    <div class="material-icons" @click="previewMode = true">visibility</div>
                </div>
                <a-select
                    class="classic-new-select"
                    :placeholder="$t('auto.sendWhatsappTemplateMessageWhatsappBusinessChannel')"
                    @change="selectTemplate"
                    :value="selectedTemplateId"
                >
                    <a-select-option v-for="(template, index) of templates" :key="index" :value="template.id">
                        {{ template.elementName || template.name }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="editor-row" v-if="selectedTemplateId">
                <div class="editor-row-title">{{ $t('auto.sendWhatsappTemplateMessageWhatsappPhoneNumber') }}</div>
                <TiptapEditor
                    placeholder="Whatsapp Phone Number"
                    :show-attributes="true"
                    :max-character-count="500"
                    automation-mode
                    v-model="clone.phoneNumber"
                />
                <div style="font-size: 12px; color: #666; margin-top: 4px;">
                    {{ $t('auto.sendWhatsappTemplateMessageSabitDeErGireceksenizLkeKodunuDaGirmenizGerekmektedirRn905551234567') }}
                </div>
            </div>
            <!-- Meta format: structured param sections -->
            <div class="meta-template-config" v-if="isMetaFormat && selectedTemplateId">
                <div class="config-layout">
                    <div class="config-area">
                <div class="meta-block">
                    <div class="meta-item">
                        <span class="meta-label">{{ $t('auto.sendWhatsappTemplateMessageTemplate') }}</span>
                        <span class="meta-value">{{ clone.template.name }}</span>
                    </div>
                    <div class="meta-item">
                        <span class="meta-label">{{ $t('auto.sendWhatsappTemplateMessageCategory') }}</span>
                        <span class="meta-value meta-tag">{{ clone.template.category }}</span>
                    </div>
                    <div class="meta-item">
                        <span class="meta-label">{{ $t('auto.sendWhatsappTemplateMessageLanguage') }}</span>
                        <span class="meta-value">{{ clone.template.language }}</span>
                    </div>
                </div>

                <div class="tabs-container" v-if="isCarousel">
                    <div class="tabs-header">
                        <div
                            v-for="(tab, idx) in carouselTabs"
                            :key="idx"
                            class="tab-item"
                            :class="{ active: activeTab === idx }"
                            @click="activeTab = idx"
                        >
                            {{ tab }}
                        </div>
                    </div>
                </div>

                <template v-if="!isCarousel">
                <div class="config-block" v-if="hasMediaHeader">
                    <div class="block-header">
                        <span class="block-title">{{ $t('auto.sendWhatsappTemplateMessageHeader') }}</span>
                        <span class="block-hint">{{ $t('auto.sendWhatsappTemplateMessageRequired') }}</span>
                    </div>
                    <div class="media-source-selection">
                        <label class="radio-option">
                            <input type="radio" value="static" v-model="mediaType" />
                            <span>{{ $t('auto.sendWhatsappTemplateMessageUploadMedia') }}</span>
                        </label>
                        <label class="radio-option">
                            <input type="radio" value="dynamic" v-model="mediaType" />
                            <span>{{ $t('auto.sendWhatsappTemplateMessageUseUrl') }}</span>
                        </label>
                    </div>
                    <div class="media-url-input" v-if="mediaType === 'dynamic'">
                        <TiptapEditor
                            placeholder="Enter URL or select attribute"
                            :show-attributes="true"
                            :max-character-count="500"
                            automation-mode
                            :value="externalUrl"
                            @change="externalUrl = $event"
                        />
                    </div>
                    <div class="media-area" v-else>
                        <div class="media-uploaded" v-if="media">
                            <img v-if="metaHeaderComponent.format === 'IMAGE'" :src="media.data" :alt="$t('auto.sendWhatsappTemplateMessagePreview')" />
                            <video v-else-if="metaHeaderComponent.format === 'VIDEO'" :src="media.data" controls />
                            <div v-else class="doc-preview">
                                <a-icon type="file" />
                                <span>{{ media.name }}</span>
                            </div>
                            <button class="remove-media" @click="deleteMedia">
                                <a-icon type="close" />
                            </button>
                        </div>
                        <label class="upload-area" v-else>
                            <input type="file" :accept="getAcceptType()" @change="handleFileUpload" />
                            <a-icon type="cloud-upload" />
                            <span class="upload-label">{{ $t('auto.sendWhatsappTemplateMessageClickToUpload') }}</span>
                            <span class="upload-format">{{ getMediaHint() }}</span>
                        </label>
                    </div>
                </div>

                <div class="config-block" v-if="metaHeaderComponent && metaHeaderComponent.format === 'TEXT' && metaHeaderParams.length > 0">
                    <div class="block-header">
                        <span class="block-title">{{ $t('auto.sendWhatsappTemplateMessageHeaderVariables') }}</span>
                    </div>
                    <div class="params-list">
                        <div v-for="(param, index) in metaHeaderParams" :key="'h-' + index" class="param-row">
                            <div class="param-info">
                                <span class="param-idx">{{ getPlaceholder(index) }}</span>
                                <span class="param-ctx">{{ getParamContext(metaHeaderComponent.text, index) }}</span>
                            </div>
                            <div class="param-controls">
                                <div class="param-mode-selection">
                                    <label class="mode-option">
                                        <input type="radio" value="static" v-model="headerParamModes[index]" />
                                        <span>{{ $t('auto.sendWhatsappTemplateMessageStatic') }}</span>
                                    </label>
                                    <label class="mode-option">
                                        <input type="radio" value="dynamic" v-model="headerParamModes[index]" />
                                        <span>{{ $t('auto.sendWhatsappTemplateMessageDinamik') }}</span>
                                    </label>
                                </div>
                                <input
                                    v-if="headerParamModes[index] === 'static'"
                                    v-model="metaHeaderParams[index]"
                                    type="text"
                                    :placeholder="$t('auto.sendWhatsappTemplateMessageEnterValue')"
                                    class="param-field"
                                />
                                <TiptapEditor
                                    v-else
                                    placeholder="Select or type attribute"
                                    :show-attributes="true"
                                    :max-character-count="500"
                                    automation-mode
                                    v-model="metaHeaderParams[index]"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="config-block" v-if="metaBodyParams.length > 0">
                    <div class="block-header">
                        <span class="block-title">{{ $t('auto.sendWhatsappTemplateMessageBodyVariables') }}</span>
                    </div>
                    <div class="params-list">
                        <div v-for="(param, index) in metaBodyParams" :key="'b-' + index" class="param-row">
                            <div class="param-info">
                                <span class="param-idx">{{ getPlaceholder(index) }}</span>
                                <span class="param-ctx">{{ getParamContext(metaBodyComponent.text, index) }}</span>
                            </div>
                            <div class="param-controls">
                                <div class="param-mode-selection">
                                    <label class="mode-option">
                                        <input type="radio" value="static" v-model="bodyParamModes[index]" />
                                        <span>{{ $t('auto.sendWhatsappTemplateMessageStatic') }}</span>
                                    </label>
                                    <label class="mode-option">
                                        <input type="radio" value="dynamic" v-model="bodyParamModes[index]" />
                                        <span>{{ $t('auto.sendWhatsappTemplateMessageDinamik') }}</span>
                                    </label>
                                </div>
                                <input
                                    v-if="bodyParamModes[index] === 'static'"
                                    v-model="metaBodyParams[index]"
                                    type="text"
                                    :placeholder="$t('auto.sendWhatsappTemplateMessageEnterValue')"
                                    class="param-field"
                                />
                                <TiptapEditor
                                    v-else
                                    placeholder="Select or type attribute"
                                    :show-attributes="true"
                                    :max-character-count="500"
                                    automation-mode
                                    v-model="metaBodyParams[index]"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="config-block" v-if="metaButtonParams.length > 0">
                    <div class="block-header">
                        <span class="block-title">{{ $t('auto.sendWhatsappTemplateMessageButtonVariables') }}</span>
                    </div>
                    <div class="params-list">
                        <div v-for="(param, index) in metaButtonParams" :key="'btn-' + index" class="param-row">
                            <div class="param-info">
                                <span class="param-idx">{{ getPlaceholder(index) }}</span>
                                <span class="param-ctx">{{ getButtonParamContext(index) }}</span>
                            </div>
                            <div class="param-controls">
                                <div class="param-mode-selection">
                                    <label class="mode-option">
                                        <input type="radio" value="static" v-model="buttonParamModes[index]" />
                                        <span>{{ $t('auto.sendWhatsappTemplateMessageStatic') }}</span>
                                    </label>
                                    <label class="mode-option">
                                        <input type="radio" value="dynamic" v-model="buttonParamModes[index]" />
                                        <span>{{ $t('auto.sendWhatsappTemplateMessageDinamik') }}</span>
                                    </label>
                                </div>
                                <input
                                    v-if="buttonParamModes[index] === 'static'"
                                    v-model="metaButtonParams[index]"
                                    type="text"
                                    :placeholder="$t('auto.sendWhatsappTemplateMessageEnterValue')"
                                    class="param-field"
                                />
                                <TiptapEditor
                                    v-else
                                    placeholder="Select or type attribute"
                                    :show-attributes="true"
                                    :max-character-count="500"
                                    automation-mode
                                    v-model="metaButtonParams[index]"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ready-state" v-if="!hasAnyMetaParams && !hasMediaHeader">
                    <div class="ready-icon">
                        <a-icon type="check" />
                    </div>
                    <div class="ready-text">{{ $t('auto.sendWhatsappTemplateMessageReadyToSend') }}</div>
                    <div class="ready-hint">{{ $t('auto.sendWhatsappTemplateMessageThisTemplateRequiresNoParameters') }}</div>
                </div>
                </template>

                <template v-else>
                    <template v-if="activeTab === 0">
                        <div class="config-block" v-if="metaBodyParams.length > 0">
                            <div class="block-header">
                                <span class="block-title">Body Variables</span>
                            </div>
                            <div class="params-list">
                                <div v-for="(param, index) in metaBodyParams" :key="'mb-' + index" class="param-row">
                                    <div class="param-info">
                                        <span class="param-idx">{{ getPlaceholder(index) }}</span>
                                        <span class="param-ctx">{{ getParamContext(metaBodyComponent.text, index) }}</span>
                                    </div>
                                    <div class="param-controls">
                                        <div class="param-mode-selection">
                                            <label class="mode-option">
                                                <input type="radio" value="static" v-model="bodyParamModes[index]" />
                                                <span>Static</span>
                                            </label>
                                            <label class="mode-option">
                                                <input type="radio" value="dynamic" v-model="bodyParamModes[index]" />
                                                <span>Dinamik</span>
                                            </label>
                                        </div>
                                        <input
                                            v-if="bodyParamModes[index] === 'static'"
                                            v-model="metaBodyParams[index]"
                                            type="text"
                                            placeholder="Enter value"
                                            class="param-field"
                                        />
                                        <TiptapEditor
                                            v-else
                                            placeholder="Select or type attribute"
                                            :show-attributes="true"
                                            :max-character-count="500"
                                            automation-mode
                                            v-model="metaBodyParams[index]"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ready-state" v-if="metaBodyParams.length === 0">
                            <div class="ready-icon">
                                <a-icon type="check" />
                            </div>
                            <div class="ready-text">No variables</div>
                            <div class="ready-hint">Main message has no parameters</div>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            v-for="(card, cardIndex) in carouselCards"
                            :key="'card-' + cardIndex"
                            v-show="activeTab === cardIndex + 1"
                        >
                            <div class="config-block" v-if="hasCarouselCardHeaderVariable(cardIndex)">
                                <div class="block-header">
                                    <span class="block-title">Header {{ getCarouselCardHeaderFormat(cardIndex) }}</span>
                                    <span class="block-hint">Required</span>
                                </div>
                                <div class="media-source-selection">
                                    <label class="radio-option">
                                        <input type="radio" :value="false" v-model="carouselCardUseUrl[cardIndex]" />
                                        <span>Upload Media</span>
                                    </label>
                                    <label class="radio-option">
                                        <input type="radio" :value="true" v-model="carouselCardUseUrl[cardIndex]" />
                                        <span>Use URL</span>
                                    </label>
                                </div>
                                <div class="media-url-input" v-if="carouselCardUseUrl[cardIndex]">
                                    <TiptapEditor
                                        placeholder="Enter URL or select attribute"
                                        :show-attributes="true"
                                        :max-character-count="500"
                                        automation-mode
                                        :value="carouselCardParams[cardIndex].header[0]"
                                        @change="setCarouselCardHeaderParam(cardIndex, 0, $event)"
                                    />
                                </div>
                                <div class="media-area" v-else>
                                    <div class="media-uploaded" v-if="carouselCardMedia[cardIndex]">
                                        <img v-if="getCarouselCardHeaderFormat(cardIndex) === 'IMAGE'" :src="carouselCardMedia[cardIndex].data" alt="Preview" />
                                        <video v-else-if="getCarouselCardHeaderFormat(cardIndex) === 'VIDEO'" :src="carouselCardMedia[cardIndex].data" controls />
                                        <div v-else class="doc-preview">
                                            <a-icon type="file" />
                                            <span>{{ carouselCardMedia[cardIndex].name }}</span>
                                        </div>
                                        <button class="remove-media" @click="removeCarouselCardMedia(cardIndex)">
                                            <a-icon type="close" />
                                        </button>
                                    </div>
                                    <label class="upload-area" v-else>
                                        <input type="file" :accept="getCarouselCardAcceptType(cardIndex)" @change="handleCarouselCardFileUpload($event, cardIndex)" />
                                        <a-icon type="cloud-upload" />
                                        <span class="upload-label">Click to upload</span>
                                        <span class="upload-format">{{ getCarouselCardMediaHint(cardIndex) }}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="config-block" v-if="carouselCardParams[cardIndex].body.length > 0">
                                <div class="block-header">
                                    <span class="block-title">Body Variables</span>
                                </div>
                                <div class="params-list">
                                    <div v-for="(param, paramIndex) in carouselCardParams[cardIndex].body" :key="'cb-' + paramIndex" class="param-row">
                                        <div class="param-info">
                                            <span class="param-idx">{{ getPlaceholder(paramIndex) }}</span>
                                            <span class="param-ctx">{{ getCarouselCardBodyContext(cardIndex, paramIndex) }}</span>
                                        </div>
                                        <div class="param-controls">
                                            <div class="param-mode-selection">
                                                <label class="mode-option">
                                                    <input type="radio" value="static" v-model="carouselCardParamModes[cardIndex].body[paramIndex]" />
                                                    <span>Static</span>
                                                </label>
                                                <label class="mode-option">
                                                    <input type="radio" value="dynamic" v-model="carouselCardParamModes[cardIndex].body[paramIndex]" />
                                                    <span>Dinamik</span>
                                                </label>
                                            </div>
                                            <input
                                                v-if="carouselCardParamModes[cardIndex].body[paramIndex] === 'static'"
                                                v-model="carouselCardParams[cardIndex].body[paramIndex]"
                                                type="text"
                                                placeholder="Enter value"
                                                class="param-field"
                                            />
                                            <TiptapEditor
                                                v-else
                                                placeholder="Select or type attribute"
                                                :show-attributes="true"
                                                :max-character-count="500"
                                                automation-mode
                                                :value="carouselCardParams[cardIndex].body[paramIndex]"
                                                @input="setCarouselCardBodyParam(cardIndex, paramIndex, $event)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="config-block" v-if="carouselCardParams[cardIndex].buttons.length > 0">
                                <div class="block-header">
                                    <span class="block-title">Button Variables</span>
                                </div>
                                <div class="params-list">
                                    <div v-for="(param, paramIndex) in carouselCardParams[cardIndex].buttons" :key="'cbtn-' + paramIndex" class="param-row">
                                        <div class="param-info">
                                            <span class="param-idx">{{ getPlaceholder(paramIndex) }}</span>
                                            <span class="param-ctx">URL suffix</span>
                                        </div>
                                        <div class="param-controls">
                                            <div class="param-mode-selection">
                                                <label class="mode-option">
                                                    <input type="radio" value="static" v-model="carouselCardParamModes[cardIndex].buttons[paramIndex]" />
                                                    <span>Static</span>
                                                </label>
                                                <label class="mode-option">
                                                    <input type="radio" value="dynamic" v-model="carouselCardParamModes[cardIndex].buttons[paramIndex]" />
                                                    <span>Dinamik</span>
                                                </label>
                                            </div>
                                            <input
                                                v-if="carouselCardParamModes[cardIndex].buttons[paramIndex] === 'static'"
                                                v-model="carouselCardParams[cardIndex].buttons[paramIndex]"
                                                type="text"
                                                placeholder="Enter value"
                                                class="param-field"
                                            />
                                            <TiptapEditor
                                                v-else
                                                placeholder="Select or type attribute"
                                                :show-attributes="true"
                                                :max-character-count="500"
                                                automation-mode
                                                :value="carouselCardParams[cardIndex].buttons[paramIndex]"
                                                @input="setCarouselCardButtonParam(cardIndex, paramIndex, $event)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ready-state" v-if="carouselCardParams[cardIndex].header.length === 0 && carouselCardParams[cardIndex].body.length === 0 && carouselCardParams[cardIndex].buttons.length === 0">
                                <div class="ready-icon">
                                    <a-icon type="check" />
                                </div>
                                <div class="ready-text">No variables</div>
                                <div class="ready-hint">This card has no parameters</div>
                            </div>
                        </div>
                    </template>
                </template>
                    </div>
                    <div class="preview-area">
                        <WhatsappMessagePreview
                            :templateType="previewTemplateType"
                            :headerMediaType="previewHeaderMediaType"
                            :headerMediaURL="previewHeaderMediaURL"
                            :headerText="previewHeaderText"
                            :body="previewBody"
                            :footer="previewFooter"
                            :buttons="previewButtons"
                            :cards="previewCards"
                            :limitedTimeOffer="previewLimitedTimeOffer"
                        />
                    </div>
                </div>
            </div>
            <!-- Gupshup format: flat params -->
            <div class="wpa-variables" v-else-if="selectedTemplateId && variables.length > 0">
                <div class="editor-row" v-for="(variable, index) of variables" :key="index">
                    <div class="editor-row-title">Variable (#{{ index + 1 }})</div>
                    <TiptapEditor
                        :placeholder="`Variable (#${index + 1})`"
                        :show-attributes="true"
                        :max-character-count="500"
                        v-model="clone.params[index]"
                        automation-mode
                    />
                </div>
            </div>
            <div
                class="image-picker"
                v-if="hasMediaHeader && !isMetaFormat"
            >
                <div class="editor-row">
                    <div class="editor-row-title">Media Type</div>
                    <a-select v-model="mediaType" placeholder="Select Media Type">
                        <a-select-option value="static">Static</a-select-option>
                        <a-select-option value="dynamic">Dynamic</a-select-option>
                    </a-select>

                    <div v-if="mediaType === 'dynamic'">
                        <TiptapEditor
                            placeholder="Dynamic Media URL"
                            :show-attributes="true"
                            :max-character-count="500"
                            automation-mode
                            v-model="externalUrl"
                        />
                    </div>
                    <div v-if="mediaType === 'static'">
                        <div class="media-preview" v-if="media">
                            <div class="media-preview-content">
                                <div class="media-image">
                                    <img :src="media.data" alt="" />
                                </div>
                                <div class="media-preview-name">
                                    {{ media.name }}
                                </div>
                            </div>
                            <div class="media-preview-delete" @click="deleteMedia">
                                <div class="material-icons">delete</div>
                            </div>
                        </div>
                        <div class="media-drag" v-else>
                            <div class="input">
                                <input
                                    type="file"
                                    id="media-source"
                                    :accept="getAcceptType()"
                                    @change="handleFileUpload"
                                />
                            </div>
                            <div class="material-icons">image</div>
                            <div class="content">Click here to upload a picture.</div>
                        </div>
                        <div class="description">
                            <div class="input-warn">
                                <div>
                                    <b>Note:</b> Following are the file formats and their respective sizes which are
                                    accepted for upload
                                </div>
                                <ul class="list-item">
                                    <li>Image: JPEG and PNG (Max size 2 MB)</li>
                                    <li>Video: MP4 (Max size 20 MB)</li>
                                    <li>Document: (Max size 2 MB)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a-spin>
        <WhatsappMessagePreview
            :body="getTemplateParameters(clone.template).body"
            :footer="getTemplateParameters(clone.template).footer"
            :header-media-type="getTemplateParameters(clone.template).headerType"
            :header-text="getTemplateParameters(clone.template).headerText"
            :buttons="getTemplateParameters(clone.template).buttons"
            :headerMediaURL="getTemplateParameters(clone.template).headerMediaURL"
            v-if="clone.template && !isMetaFormat"
        />
    </div>
</template>

<script>
import "../../../../Whatsapp/pages/broadcast/create/broadcast.scss";
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import TemplateMessageSelector from "../../../../Whatsapp/pages/broadcast/create/TemplateMessageSelector.vue";
import { uploadAsset } from "../../../../../../api/assetUpload";
import axios from "axios";
import Modal2 from "../../../../../../components/common/Modal2.vue";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import WhatsappMessagePreview from "../../../../WhatsappBusinessGupshup/WhatsappMessagePreview.vue";

const log = log2("SendWhatsappTemplateMessage");
export default {
    name: "SendWhatsappTemplateMessage",
    components: { WhatsappMessagePreview, Modal2, TemplateMessageSelector, TiptapEditor },
    props: ["value"],
    data() {
        var initialClone = _.cloneDeep(this.value);
        if (initialClone.templateParamsByTemplateId) delete initialClone.templateParamsByTemplateId;
        return {
            loading: false,
            clone: initialClone,
            templateParamsByTemplateId: {},
            templates: [],
            selectedTemplateId: null,
            variables: [],
            media: null,
            useDefault: false,
            previewMode: false,
            mediaType: "static",
            externalUrl: "",
            metaHeaderParams: [],
            metaBodyParams: [],
            metaButtonParams: [],
            headerParamModes: [],
            bodyParamModes: [],
            buttonParamModes: [],
            activeTab: 0,
            carouselCardParams: [],
            carouselCardMedia: [],
            carouselCardUseUrl: [],
            carouselCardParamModes: [],
            carouselCardImageUrlMode: [],
            expirationDate: null,
            expirationDateMode: "static",
            expirationDateAttribute: null,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            businessChannels: (state) =>
                state.channel.channels.filter((channel) => 
                    channel.type === "whatsapp-business-api" || channel.type === "whatsapp-business-api-supsis"
                ),
        }),
        isSupsisWabaChannel() {
            var id = this.clone.channelId;
            var ch = this.businessChannels.find(function (c) {
                return c._id === id;
            });
            return ch && ch.type === "whatsapp-business-api-supsis";
        },
        selectedWabaChannel() {
            var id = this.clone.channelId;
            return this.businessChannels.find(function (c) {
                return c._id === id;
            });
        },
        channelMmliteOnboarded() {
            var ch = this.selectedWabaChannel;
            if (!ch || !ch.payload) return false;
            return ch.payload.marketingMessagesOnboardingStatus === "ONBOARDED";
        },
        selectedTemplateIsMarketing() {
            var t = this.clone.template;
            if (!t || !t.category) return false;
            return String(t.category).toUpperCase() === "MARKETING";
        },
        isMmliteSendChoiceAvailable() {
            return this.isSupsisWabaChannel && this.channelMmliteOnboarded && this.selectedTemplateIsMarketing;
        },
        isMetaFormat() {
            var t = this.clone.template;
            return t && t.format === "meta" && t.components;
        },
        metaHeaderComponent() {
            if (!this.isMetaFormat) return null;
            return this.clone.template.components.find(function (c) { return c.type === "HEADER"; });
        },
        metaBodyComponent() {
            if (!this.isMetaFormat) return null;
            return this.clone.template.components.find(function (c) { return c.type === "BODY"; });
        },
        metaButtonsComponent() {
            if (!this.isMetaFormat) return null;
            return this.clone.template.components.find(function (c) { return c.type === "BUTTONS"; });
        },
        hasAnyMetaParams() {
            if (this.isCarousel) {
                return this.metaBodyParams.length > 0 ||
                    (this.carouselCardParams && this.carouselCardParams.some(function (c) {
                        return c.header.length > 0 || c.body.length > 0 || c.buttons.length > 0;
                    }));
            }
            return this.metaHeaderParams.length > 0 || this.metaBodyParams.length > 0 || this.metaButtonParams.length > 0;
        },
        carouselComponent() {
            if (!this.isMetaFormat) return null;
            return this.clone.template.components.find(function (c) { return c.type === "CAROUSEL"; });
        },
        isCarousel() {
            return !!this.carouselComponent;
        },
        carouselCards() {
            if (!this.carouselComponent || !this.carouselComponent.cards) return [];
            return this.carouselComponent.cards;
        },
        carouselTabs() {
            var tabs = ["Main Message"];
            this.carouselCards.forEach(function (_, index) {
                tabs.push("Card " + (index + 1));
            });
            return tabs;
        },
        limitedTimeOfferComponent() {
            if (!this.isMetaFormat) return null;
            return this.clone.template.components.find(function (c) { return c.type === "LIMITED_TIME_OFFER"; });
        },
        previewTemplateType() {
            if (this.isCarousel) return "CAROUSEL";
            if (this.limitedTimeOfferComponent) return "LIMITED_TIME_OFFER";
            return this.clone.template.category || "CUSTOM_MESSAGE";
        },
        previewHeaderMediaType() {
            if (!this.metaHeaderComponent) return null;
            if (["IMAGE", "VIDEO", "DOCUMENT"].includes(this.metaHeaderComponent.format)) {
                return this.metaHeaderComponent.format;
            }
            return null;
        },
        previewHeaderMediaURL() {
            if (this.hasMediaHeader && this.metaHeaderParams.length > 0 && this.metaHeaderParams[0]) {
                return this.metaHeaderParams[0];
            }
            if (this.media) return this.media.data;
            if (this.mediaType === "dynamic" && this.externalUrl) return this.externalUrl;
            var t = this.clone.template;
            if (t && t.mediaPayload && t.mediaPayload.headerAsset && t.mediaPayload.headerAsset.cdnUrl) {
                return t.mediaPayload.headerAsset.cdnUrl;
            }
            if (t && t.cdnUrl) return t.cdnUrl;
            return null;
        },
        previewHeaderText() {
            if (!this.metaHeaderComponent || this.metaHeaderComponent.format !== "TEXT") return "";
            var text = this.metaHeaderComponent.text || "";
            this.metaHeaderParams.forEach(function (value, index) {
                var placeholder = "{{" + (index + 1) + "}}";
                var displayValue = value ? value : "[" + (index + 1) + "]";
                text = text.replace(placeholder, displayValue);
            });
            return text;
        },
        previewBody() {
            if (!this.metaBodyComponent) return "";
            var text = this.metaBodyComponent.text || "";
            this.metaBodyParams.forEach(function (value, index) {
                var placeholder = "{{" + (index + 1) + "}}";
                var displayValue = value ? value : "[" + (index + 1) + "]";
                text = text.replace(placeholder, displayValue);
            });
            return text;
        },
        previewFooter() {
            var fc = this.clone.template.components && this.clone.template.components.find(function (c) { return c.type === "FOOTER"; });
            return fc ? fc.text : null;
        },
        previewButtons() {
            if (!this.metaButtonsComponent) return [];
            var buttons = this.metaButtonsComponent.buttons || [];
            var btnIndex = 0;
            var self = this;
            return buttons.map(function (btn) {
                var button = _.assign({}, btn);
                if (btn.type === "URL" && btn.url && btn.url.indexOf("{{") !== -1) {
                    var matches = btn.url.match(/\{\{\d+\}\}/g);
                    if (matches && btnIndex < self.metaButtonParams.length) {
                        var url = btn.url;
                        matches.forEach(function () {
                            var pv = self.metaButtonParams[btnIndex];
                            url = url.replace(/\{\{\d+\}\}/, pv ? pv : "[suffix]");
                            btnIndex++;
                        });
                        button.url = url;
                    }
                } else if (btn.type === "COPY_CODE") {
                    button.text = "Copy code";
                    if (btnIndex < self.metaButtonParams.length) btnIndex++;
                }
                return button;
            });
        },
        previewCards() {
            if (!this.isCarousel || !this.carouselCardParams) return [];
            var self = this;
            return this.carouselCards.map(function (card, cardIndex) {
                var cardComponents = card.components || [];
                var headerComp = cardComponents.find(function (c) { return c.type === "HEADER"; });
                var bodyComp = cardComponents.find(function (c) { return c.type === "BODY"; });
                var buttonsComp = cardComponents.find(function (c) { return c.type === "BUTTONS"; });
                var cardParam = self.carouselCardParams[cardIndex] || { header: [], body: [], buttons: [] };
                var mediaUrl = null;
                var headerType = null;
                if (headerComp && ["IMAGE", "VIDEO", "DOCUMENT"].includes(headerComp.format)) {
                    headerType = headerComp.format;
                    if (cardParam.header && cardParam.header[0]) {
                        mediaUrl = cardParam.header[0];
                    } else if (self.carouselCardMedia && self.carouselCardMedia[cardIndex]) {
                        mediaUrl = self.carouselCardMedia[cardIndex].data;
                    } else {
                        var t = self.clone.template;
                        if (t && t.mediaPayload && t.mediaPayload.cardAssets && t.mediaPayload.cardAssets[cardIndex]) {
                            mediaUrl = t.mediaPayload.cardAssets[cardIndex].cdnUrl;
                        }
                    }
                }
                var sampleText = "";
                if (bodyComp && bodyComp.text) {
                    sampleText = bodyComp.text;
                    if (cardParam.body) {
                        cardParam.body.forEach(function (value, index) {
                            var placeholder = "{{" + (index + 1) + "}}";
                            sampleText = sampleText.replace(placeholder, value ? value : "[" + (index + 1) + "]");
                        });
                    }
                }
                var previewButtons = [];
                if (buttonsComp && buttonsComp.buttons && cardParam.buttons) {
                    var bpIdx = 0;
                    previewButtons = buttonsComp.buttons.map(function (btn) {
                        var b = _.assign({}, btn);
                        if (btn.type === "URL" && btn.url && btn.url.indexOf("{{") !== -1 && cardParam.buttons) {
                            var m = btn.url.match(/\{\{\d+\}\}/g);
                            if (m) {
                                var u = btn.url;
                                m.forEach(function () {
                                    if (bpIdx < cardParam.buttons.length) {
                                        u = u.replace(/\{\{\d+\}\}/, cardParam.buttons[bpIdx] || "[suffix]");
                                        bpIdx++;
                                    }
                                });
                                b.url = u;
                            }
                        } else if (btn.type === "COPY_CODE") {
                            b.text = "Copy code";
                            if (bpIdx < cardParam.buttons.length) bpIdx++;
                        }
                        return b;
                    });
                }
                return { mediaUrl: mediaUrl, headerType: headerType, sampleText: sampleText, buttons: previewButtons };
            });
        },
        previewLimitedTimeOffer() {
            if (!this.limitedTimeOfferComponent) return null;
            var lto = this.limitedTimeOfferComponent.limited_time_offer || {};
            return {
                text: lto.text || "",
                hasExpiration: lto.has_expiration !== false,
                expirationDate: this.expirationDate || null,
            };
        },
        hasMediaHeader() {
            const template = this.clone.template;
            if (!template) return false;

            // Meta format için
            if (template.format === "meta" && template.components) {
                const headerComponent = template.components.find((c) => c.type === "HEADER");
                return headerComponent && ["IMAGE", "VIDEO", "DOCUMENT"].includes(headerComponent.format);
            }

            // Gupshup format için
            return ["IMAGE", "VIDEO", "DOCUMENT"].includes(template.templateType);
        },
    },
    methods: {
        ...mapActions({
            getTemplates: "whatsapp/getTemplates",
        }),
        getTemplateParameters(template) {
            if (!template) {
                return {
                    headerType: "TEXT",
                    headerMediaType: "TEXT",
                    headerMediaURL: null,
                    headerText: null,
                    footer: null,
                    body: "",
                    buttons: [],
                };
            }

            // Meta format için (whatsapp-business-api-supsis)
            if (template.format === "meta" && template.components) {
                const components = template.components || [];
                const headerComponent = components.find((c) => c.type === "HEADER");
                const bodyComponent = components.find((c) => c.type === "BODY");
                const footerComponent = components.find((c) => c.type === "FOOTER");
                const buttonsComponent = components.find((c) => c.type === "BUTTONS");

                let headerType = "TEXT";
                let headerMediaURL = null;
                let headerText = null;

                if (headerComponent) {
                    if (headerComponent.format === "IMAGE") {
                        headerType = "IMAGE";
                        headerMediaURL = this.mediaType === "dynamic"
                            ? ""
                            : this.media?.asset?.url || null;
                    } else if (headerComponent.format === "VIDEO") {
                        headerType = "VIDEO";
                        headerMediaURL = this.mediaType === "dynamic"
                            ? ""
                            : this.media?.asset?.url || null;
                    } else if (headerComponent.format === "DOCUMENT") {
                        headerType = "DOCUMENT";
                        headerMediaURL = this.mediaType === "dynamic"
                            ? ""
                            : this.media?.asset?.url || null;
                    } else if (headerComponent.format === "TEXT") {
                        headerText = headerComponent.text;
                    }
                }

                return {
                    headerType,
                    headerMediaType: headerType,
                    headerMediaURL,
                    headerText,
                    footer: footerComponent ? footerComponent.text : null,
                    body: bodyComponent ? bodyComponent.text : "",
                    buttons: buttonsComponent ? buttonsComponent.buttons : [],
                };
            }

            // Gupshup format için (whatsapp-business-api)
            const metaObject = typeof template.meta === "string" ? JSON.parse(template.meta) : template.meta || {};
            const containerMetaObj = typeof template.containerMeta === "string" 
                ? JSON.parse(template.containerMeta) 
                : template.containerMeta || {};

            return {
                headerType: template.templateType,
                headerMediaType: template.templateType,
                headerMediaURL:
                    this.mediaType === "dynamic"
                        ? ""
                        : this.media?.asset
                        ? this.media?.asset.url
                        : template.asset &&
                          (template.asset.v2Format && template.asset.cdnUrl
                              ? template.asset.cdnUrl
                              : `https://static.supsis.live/${template.asset.path}${template.asset.id}.${template.asset.ext}`),
                headerText: _.get(containerMetaObj, "header"),
                footer: _.get(containerMetaObj, "footer"),
                body: _.get(metaObject, "example") || metaObject.data,
                buttons: _.get(containerMetaObj, "buttons") || template.buttons,
            };
        },
        syncMmliteSendDefault() {
            if (!this.isSupsisWabaChannel) return;
            if (!this.isMmliteSendChoiceAvailable) {
                this.$set(this.clone, "sendTemplateViaMmlite", false);
                return;
            }
            if (this.clone.sendTemplateViaMmlite === undefined) {
                this.$set(this.clone, "sendTemplateViaMmlite", true);
            }
        },
        getChannelTemplates() {
            if (!this.clone.channelId) return;
            this.loading = true;
            this.getTemplates(this.clone.channelId).then((templates) => {
                this.loading = false;
                this.templates = templates;
                this.media = this.clone.asset && {
                    ...this.clone?.asset,
                    data: this.clone?.asset?.url,
                    asset: this.clone?.asset,
                };
                this.migrateLegacyTemplateParamsMap();
                this.selectedTemplate = this.selectTemplate(this.clone.template?.id);
            });
        },
        migrateLegacyTemplateParamsMap() {
            var t = this.clone.template;
            var tp = this.clone.templateParams;
            if (!t || !t.id || !tp || typeof tp !== "object") return;
            if (Object.prototype.hasOwnProperty.call(this.templateParamsByTemplateId, t.id)) return;
            this.$set(this.templateParamsByTemplateId, t.id, _.cloneDeep(tp));
        },
        stashCurrentMetaTemplateParamsToMap(prevTemplateId) {
            if (!prevTemplateId) return;
            this.syncMetaTemplateParams();
            this.$set(this.templateParamsByTemplateId, prevTemplateId, _.cloneDeep(this.clone.templateParams));
        },
        selectTemplate(templateId) {
            var prevId = this.selectedTemplateId;
            var prevTpl = this.clone.template;
            if (
                prevId &&
                prevId !== templateId &&
                prevTpl &&
                prevTpl.format === "meta" &&
                prevTpl.components
            ) {
                this.stashCurrentMetaTemplateParamsToMap(prevId);
            }
            const template = this.templates.find((t) => t.id === templateId);
            this.selectedTemplateId = templateId;
            this.clone.template = template;
            if (template) {
                this.getParams();
            }
        },
        normalizeParamModes(savedModes, length) {
            var out = [];
            for (var i = 0; i < length; i++) {
                out.push(savedModes && savedModes[i] === "dynamic" ? "dynamic" : "static");
            }
            return out;
        },
        getParams() {
            const template = this.clone.template;
            if (!template) return;

            // Meta format için (whatsapp-business-api-supsis)
            if (template.format === "meta" && template.components) {
                var self = this;
                var byId = this.templateParamsByTemplateId || {};
                var tid = template.id;
                var existingTP = {};
                if (tid && Object.prototype.hasOwnProperty.call(byId, tid)) {
                    existingTP = byId[tid] || {};
                }
                var components = template.components || [];
                var headerComponent = components.find(function (c) { return c.type === "HEADER"; });
                var bodyComponent = components.find(function (c) { return c.type === "BODY"; });
                var buttonsComponent = components.find(function (c) { return c.type === "BUTTONS"; });
                var carouselComponent = components.find(function (c) { return c.type === "CAROUSEL"; });
                var isCarousel = !!carouselComponent;
                var carouselCards = (carouselComponent && carouselComponent.cards) || [];

                this.activeTab = 0;

                if (isCarousel) {
                    this.metaHeaderParams = [];
                    this.metaButtonParams = [];
                    if (bodyComponent && bodyComponent.text) {
                        var bMatches = bodyComponent.text.match(/\{\{\d+\}\}/g) || [];
                        this.metaBodyParams = bMatches.map(function (_, i) {
                            return (existingTP.body && existingTP.body[i]) || "";
                        });
                    } else {
                        this.metaBodyParams = [];
                    }
                    this.bodyParamModes = self.normalizeParamModes(existingTP.bodyParamModes, this.metaBodyParams.length);

                    this.carouselCardMedia = [];
                    this.carouselCardUseUrl = [];
                    this.carouselCardImageUrlMode = [];
                    for (var i = 0; i < carouselCards.length; i++) {
                        this.$set(this.carouselCardMedia, i, null);
                        this.$set(this.carouselCardUseUrl, i, false);
                        this.$set(this.carouselCardImageUrlMode, i, "static");
                    }

                    var existingCarousel = existingTP.carousel || [];
                    this.carouselCardParams = carouselCards.map(function (card, cardIndex) {
                        var cardComponents = card.components || [];
                        var hComp = cardComponents.find(function (c) { return c.type === "HEADER"; });
                        var bComp = cardComponents.find(function (c) { return c.type === "BODY"; });
                        var btnComp = cardComponents.find(function (c) { return c.type === "BUTTONS"; });
                        var ec = existingCarousel[cardIndex] || {};
                        var cardParam = { header: [], body: [], buttons: [] };
                        if (hComp && ["IMAGE", "VIDEO", "DOCUMENT"].indexOf(hComp.format) !== -1) {
                            cardParam.header = [(ec.header && ec.header[0]) || ""];
                        }
                        if (bComp && bComp.text) {
                            var matches = bComp.text.match(/\{\{\d+\}\}/g) || [];
                            cardParam.body = matches.map(function (_, idx) {
                                return (ec.body && ec.body[idx]) || "";
                            });
                        }
                        if (btnComp && btnComp.buttons) {
                            var bc = 0;
                            btnComp.buttons.forEach(function (btn) {
                                if (btn.type === "URL" && btn.url && btn.url.indexOf("{{") !== -1) bc++;
                                else if (btn.type === "COPY_CODE") bc++;
                            });
                            cardParam.buttons = new Array(bc).fill("").map(function (_, idx) {
                                return (ec.buttons && ec.buttons[idx]) || "";
                            });
                        }
                        return cardParam;
                    });

                    this.carouselCardParamModes = carouselCards.map(function (card, cardIndex) {
                        var cardComponents = card.components || [];
                        var bComp = cardComponents.find(function (c) { return c.type === "BODY"; });
                        var btnComp = cardComponents.find(function (c) { return c.type === "BUTTONS"; });
                        var ec = existingCarousel[cardIndex] || {};
                        var cardMode = { header: [], body: [], buttons: [] };
                        if (bComp && bComp.text) {
                            var matches = bComp.text.match(/\{\{\d+\}\}/g) || [];
                            cardMode.body = self.normalizeParamModes(ec.bodyModes || ec.bodyParamModes, matches.length);
                        }
                        if (btnComp && btnComp.buttons) {
                            var bc = 0;
                            btnComp.buttons.forEach(function (btn) {
                                if (btn.type === "URL" && btn.url && btn.url.indexOf("{{") !== -1) bc++;
                                else if (btn.type === "COPY_CODE") bc++;
                            });
                            cardMode.buttons = self.normalizeParamModes(ec.buttonModes || ec.buttonParamModes, bc);
                        }
                        return cardMode;
                    });

                    for (var mi = 0; mi < carouselCards.length; mi++) {
                        var ecRestore = existingCarousel[mi] || {};
                        var savedUrl = this.carouselCardParams[mi] && this.carouselCardParams[mi].header[0];
                        if (ecRestore.type === "url") {
                            this.$set(this.carouselCardUseUrl, mi, true);
                        } else if (savedUrl) {
                            this.$set(this.carouselCardMedia, mi, { data: savedUrl, name: "Uploaded media" });
                        } else if (ecRestore.type === "upload") {
                            // Upload seçildi ama dosya yok — şablon önizlemesi gösterme
                        } else {
                            var cardAsset = template.mediaPayload && template.mediaPayload.cardAssets && template.mediaPayload.cardAssets[mi];
                            if (cardAsset && cardAsset.cdnUrl) {
                                this.$set(this.carouselCardMedia, mi, { data: cardAsset.cdnUrl, name: "Template default" });
                            }
                        }
                    }
                } else {
                    if (headerComponent && headerComponent.format === "TEXT" && headerComponent.text) {
                        var hMatches = headerComponent.text.match(/\{\{\d+\}\}/g) || [];
                        this.metaHeaderParams = hMatches.map(function (_, i) {
                            return (existingTP.header && existingTP.header[i]) || "";
                        });
                    } else {
                        this.metaHeaderParams = [];
                    }
                    if (bodyComponent && bodyComponent.text) {
                        var bMatches = bodyComponent.text.match(/\{\{\d+\}\}/g) || [];
                        this.metaBodyParams = bMatches.map(function (_, i) {
                            return (existingTP.body && existingTP.body[i]) || "";
                        });
                    } else {
                        this.metaBodyParams = [];
                    }
                    var btnParams = [];
                    if (buttonsComponent && buttonsComponent.buttons) {
                        var btnIndex = 0;
                        buttonsComponent.buttons.forEach(function (btn) {
                            if (btn.type === "URL" && btn.url && btn.url.indexOf("{{") !== -1) {
                                btnParams.push((existingTP.button && existingTP.button[btnIndex]) || "");
                                btnIndex++;
                            } else if (btn.type === "COPY_CODE") {
                                btnParams.push((existingTP.button && existingTP.button[btnIndex]) || "");
                                btnIndex++;
                            }
                        });
                    }
                    this.metaButtonParams = btnParams;
                    this.headerParamModes = self.normalizeParamModes(existingTP.headerParamModes, this.metaHeaderParams.length);
                    this.bodyParamModes = self.normalizeParamModes(existingTP.bodyParamModes, this.metaBodyParams.length);
                    this.buttonParamModes = self.normalizeParamModes(existingTP.buttonParamModes, btnParams.length);
                    this.carouselCardParams = [];

                    if (headerComponent && ["IMAGE", "VIDEO", "DOCUMENT"].indexOf(headerComponent.format) !== -1) {
                        if (existingTP.headerMediaType === "url") {
                            this.mediaType = "dynamic";
                            this.externalUrl = (existingTP.header && existingTP.header[0]) || "";
                            this.media = null;
                            this.clone.asset = { externalUrl: this.externalUrl };
                        } else if (this.media) {
                            this.mediaType = "static";
                        } else {
                            this.mediaType = "static";
                            if (existingTP.headerMediaType === "upload") {
                                // Upload seçildi ama dosya yok — şablon önizlemesi gösterme
                                this.media = null;
                            } else {
                                var headerAsset = template.mediaPayload && template.mediaPayload.headerAsset;
                                if (headerAsset && headerAsset.cdnUrl) {
                                    this.media = { data: headerAsset.cdnUrl, name: "Template default" };
                                }
                            }
                        }
                    }
                }

                this.variables = [];
                this.syncMetaTemplateParams();
                return;
            }

            // Gupshup format için (whatsapp-business-api)
            const templateType = template.templateType;
            const containerMetaObj = typeof template.containerMeta === "string" 
                ? JSON.parse(template.containerMeta) 
                : template.containerMeta || {};
            const headerText = _.get(containerMetaObj, "header", "");
            let cardVariableSize = 0;
            if (templateType === "CAROUSEL") {
                const cards = containerMetaObj.cards || [];
                cardVariableSize = cards
                    .map((card) => {
                        return card.body.match(/{{\d+}}/g);
                    })
                    .flat()
                    .filter(Boolean).length;
            }
            const buttonVariableSize = (containerMetaObj.buttons || [])
                .filter((button) => button.type === "URL")
                .map((button) => {
                    return button.url ? button.url.match(/{{\d+}}/g) : [];
                })
                .flat()
                .filter(Boolean).length;
            
            const bodyText = template.data || "";
            this.variables = [
                ..._.uniq(headerText.match(/{{\d+}}/g) || []),
                ..._.uniq(bodyText.match(/{{\d+}}/g) || []),
                ...new Array(cardVariableSize).fill(null),
                ...new Array(buttonVariableSize).fill(null),
            ].map(() => "");
            this.clone.params = new Array(this.variables.length).fill("").map((val, index) => {
                return this.clone.params[index] || val;
            });
        },
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const imageMime = ["image/jpeg", "image/png"];
                const videoMime = ["video/mp4"];
                const pdfMimeType = ["application/pdf"];
                const mb = file.size / 1024 / 1024;
                if (imageMime.includes(file.type) && mb >= 2) {
                    this.$message.error("The image could not be uploaded because it is more than 2 MB.", 3);
                    return;
                }
                if (videoMime.includes(file.type) && mb >= 20) {
                    this.$message.error("The video could not be uploaded because it is more than 20 MB.", 3);
                    return;
                }

                if (pdfMimeType.includes(file.type) && mb >= 2) {
                    this.$message.error("The document could not be uploaded because it is more than 2 MB.", 3);
                    return;
                }

                // here
                this.$message.loading("Image uploading, please wait...", 5);

                let path = `${this.siteId}/whatsapp-business/${this.clone.channelId}/assets/`;
                let imgUploadData = await uploadAsset({
                    path,
                    name: file.name,
                    size: file.size,
                    type: "gupshup-file",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });

                await axios({
                    method: imgUploadData.data.method,
                    url: imgUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": file.type },
                });

                this.media = {
                    data: URL.createObjectURL(file),
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    asset: {
                        id: imgUploadData.data.asset.id,
                        url:
                            imgUploadData.data.asset.v2Format && imgUploadData.data.asset.cdnUrl
                                ? imgUploadData.data.asset.cdnUrl
                                : `https://static.supsis.live/${imgUploadData.data.asset.path}${imgUploadData.data.asset.id}.${imgUploadData.data.asset.ext}`,
                        name: file.name,
                        ext: imgUploadData.data.asset.ext,
                        path: imgUploadData.data.asset.path,
                    },
                };

                this.clone.asset = this.media.asset;
                this.$message.success("Resim başarılı bir şekilde yüklendi.");
            }
        },
        getAcceptType() {
            const template = this.clone.template;
            if (!template) return "";

            let templateType = null;

            // Meta format için (whatsapp-business-api-supsis)
            if (template.format === "meta" && template.components) {
                const headerComponent = template.components.find((c) => c.type === "HEADER");
                if (headerComponent && headerComponent.format) {
                    templateType = headerComponent.format; // IMAGE, VIDEO, DOCUMENT
                }
            } else {
                // Gupshup format için (whatsapp-business-api)
                templateType = template.templateType;
            }

            let types = [];
            if (templateType === "IMAGE") {
                types = _.concat(types, ["image/jpeg", "image/png"]);
            } else if (templateType === "VIDEO") {
                types = _.concat(types, ["video/mp4"]);
            } else if (templateType === "DOCUMENT") {
                types = _.concat(types, ["application/pdf"]);
            }
            return types.join(" ,");
        },
        deleteMedia() {
            this.media = null;
            this.clone.asset = null;
        },
        syncMetaTemplateParams() {
            var self = this;
            if (this.isCarousel) {
                this.clone.templateParams = {
                    body: this.metaBodyParams.slice(),
                    bodyParamModes: this.bodyParamModes.slice(),
                    carousel: this.carouselCardParams.map(function (c, idx) {
                        var modes = self.carouselCardParamModes[idx] || { body: [], buttons: [] };
                        return {
                            header: c.header.slice(),
                            body: c.body.slice(),
                            buttons: c.buttons.slice(),
                            type: self.carouselCardUseUrl[idx] ? "url" : "upload",
                            bodyModes: modes.body.slice(),
                            buttonModes: modes.buttons.slice(),
                        };
                    }),
                };
            } else {
                var headerForParams = this.metaHeaderParams.slice();
                if (this.isMetaFormat && this.hasMediaHeader && this.mediaType === "dynamic") {
                    headerForParams = [this.externalUrl != null ? String(this.externalUrl) : ""];
                }
                this.clone.templateParams = {
                    header: headerForParams,
                    body: this.metaBodyParams.slice(),
                    button: this.metaButtonParams.slice(),
                    headerMediaType: this.mediaType === "dynamic" ? "url" : "upload",
                    headerParamModes: this.headerParamModes.slice(),
                    bodyParamModes: this.bodyParamModes.slice(),
                    buttonParamModes: this.buttonParamModes.slice(),
                };
            }
            var tidSync = this.clone.template && this.clone.template.id;
            if (tidSync) {
                this.$set(this.templateParamsByTemplateId, tidSync, _.cloneDeep(this.clone.templateParams));
            }
        },
        getButtonParamContext(index) {
            if (!this.metaButtonsComponent || !this.metaButtonsComponent.buttons) return "Button param";
            var paramIndex = 0;
            for (var i = 0; i < this.metaButtonsComponent.buttons.length; i++) {
                var btn = this.metaButtonsComponent.buttons[i];
                if (btn.type === "URL" && btn.url && btn.url.includes("{{")) {
                    if (paramIndex === index) {
                        return "URL suffix (" + (btn.text || "Button") + ")";
                    }
                    paramIndex++;
                } else if (btn.type === "COPY_CODE") {
                    if (paramIndex === index) {
                        return "Copy code (" + (btn.text || "Button") + ")";
                    }
                    paramIndex++;
                }
            }
            return "Button param";
        },
        hasCarouselCardHeaderVariable(cardIndex) {
            if (!this.carouselCards[cardIndex]) return false;
            var card = this.carouselCards[cardIndex];
            var headerComp = (card.components || []).find(function (c) { return c.type === "HEADER"; });
            return headerComp && ["IMAGE", "VIDEO", "DOCUMENT"].indexOf(headerComp.format) !== -1;
        },
        getCarouselCardHeaderFormat(cardIndex) {
            if (!this.carouselCards[cardIndex]) return "";
            var card = this.carouselCards[cardIndex];
            var headerComp = (card.components || []).find(function (c) { return c.type === "HEADER"; });
            return headerComp ? headerComp.format : "";
        },
        getCarouselCardBodyContext(cardIndex, paramIndex) {
            if (!this.carouselCards[cardIndex]) return "";
            var card = this.carouselCards[cardIndex];
            var bodyComp = (card.components || []).find(function (c) { return c.type === "BODY"; });
            if (!bodyComp || !bodyComp.text) return "";
            return this.getParamContext(bodyComp.text, paramIndex);
        },
        getCarouselCardAcceptType(cardIndex) {
            var format = this.getCarouselCardHeaderFormat(cardIndex);
            if (format === "IMAGE") return "image/jpeg, image/png";
            if (format === "VIDEO") return "video/mp4";
            if (format === "DOCUMENT") return "application/pdf";
            return "";
        },
        getCarouselCardMediaHint(cardIndex) {
            var format = this.getCarouselCardHeaderFormat(cardIndex);
            if (format === "IMAGE") return "JPEG, PNG (Max 2 MB)";
            if (format === "VIDEO") return "MP4 (Max 20 MB)";
            if (format === "DOCUMENT") return "PDF (Max 2 MB)";
            return "";
        },
        setCarouselCardHeaderParam(cardIndex, paramIndex, val) {
            this.$set(this.carouselCardParams[cardIndex].header, paramIndex, val);
            this.syncMetaTemplateParams();
        },
        setCarouselCardBodyParam(cardIndex, paramIndex, val) {
            this.$set(this.carouselCardParams[cardIndex].body, paramIndex, val);
            this.syncMetaTemplateParams();
        },
        setCarouselCardButtonParam(cardIndex, paramIndex, val) {
            this.$set(this.carouselCardParams[cardIndex].buttons, paramIndex, val);
            this.syncMetaTemplateParams();
        },
        async handleCarouselCardFileUpload(event, cardIndex) {
            var file = event.target.files[0];
            if (!file) return;
            var mb = file.size / 1024 / 1024;
            var format = this.getCarouselCardHeaderFormat(cardIndex);
            if (format === "IMAGE" && mb >= 2) {
                this.$message.error("The image could not be uploaded because it is more than 2 MB.", 3);
                return;
            }
            if (format === "VIDEO" && mb >= 20) {
                this.$message.error("The video could not be uploaded because it is more than 20 MB.", 3);
                return;
            }
            if (format === "DOCUMENT" && mb >= 2) {
                this.$message.error("The document could not be uploaded because it is more than 2 MB.", 3);
                return;
            }
            this.$message.loading("Image uploading, please wait...", 5);
            try {
                var path = this.siteId + "/whatsapp-business/" + this.clone.channelId + "/assets/";
                var imgUploadData = await uploadAsset({
                    path: path,
                    name: file.name,
                    size: file.size,
                    type: "gupshup-file",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });
                await axios({
                    method: imgUploadData.data.method,
                    url: imgUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": file.type },
                });
                var cdnUrl = imgUploadData.data.asset.v2Format && imgUploadData.data.asset.cdnUrl
                    ? imgUploadData.data.asset.cdnUrl
                    : "https://static.supsis.live/" + imgUploadData.data.asset.path + imgUploadData.data.asset.id + "." + imgUploadData.data.asset.ext;
                this.$set(this.carouselCardMedia, cardIndex, {
                    data: URL.createObjectURL(file),
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    asset: imgUploadData.data.asset,
                });
                this.carouselCardParams[cardIndex].header[0] = cdnUrl;
                this.$message.success("Resim başarılı bir şekilde yüklendi.");
                this.syncMetaTemplateParams();
            } catch (err) {
                this.$message.error("Upload failed");
            }
        },
        removeCarouselCardMedia(cardIndex) {
            this.$set(this.carouselCardMedia, cardIndex, null);
            this.carouselCardParams[cardIndex].header[0] = "";
            this.syncMetaTemplateParams();
        },
        getPlaceholder(index) {
            return "{{" + (index + 1) + "}}";
        },
        getMediaHint() {
            if (!this.metaHeaderComponent) return "";
            var format = this.metaHeaderComponent.format;
            if (format === "IMAGE") return "JPEG, PNG (Max 2 MB)";
            if (format === "VIDEO") return "MP4 (Max 20 MB)";
            if (format === "DOCUMENT") return "PDF (Max 2 MB)";
            return "";
        },
        getParamContext(text, index) {
            if (!text) return "";
            var placeholder = "{{" + (index + 1) + "}}";
            var position = text.indexOf(placeholder);
            if (position === -1) return "";
            var start = Math.max(0, position - 20);
            var end = Math.min(text.length, position + placeholder.length + 20);
            var context = text.substring(start, end);
            if (start > 0) context = "..." + context;
            if (end < text.length) context = context + "...";
            return context;
        },
    },
    mounted() {
        var tpl = this.clone.template;
        var tp = this.clone.templateParams;
        if (tpl && tpl.format === "meta" && tp && tp.headerMediaType === "url") {
            this.mediaType = "dynamic";
            this.externalUrl = (tp.header && tp.header[0]) || "";
            this.clone.asset = { externalUrl: this.externalUrl };
        } else {
            this.mediaType = this.clone.asset?.externalUrl ? "dynamic" : "static";
            if (this.mediaType === "dynamic") this.externalUrl = this.clone.asset?.externalUrl || "";
        }
        this.syncMmliteSendDefault();
        this.getChannelTemplates();
    },
    watch: {
        metaHeaderParams: { deep: true, handler() { if (this.isMetaFormat && !this.isCarousel) this.syncMetaTemplateParams(); } },
        metaBodyParams: { deep: true, handler() { if (this.isMetaFormat) this.syncMetaTemplateParams(); } },
        metaButtonParams: { deep: true, handler() { if (this.isMetaFormat && !this.isCarousel) this.syncMetaTemplateParams(); } },
        headerParamModes: { deep: true, handler() { if (this.isMetaFormat && !this.isCarousel) this.syncMetaTemplateParams(); } },
        bodyParamModes: { deep: true, handler() { if (this.isMetaFormat) this.syncMetaTemplateParams(); } },
        buttonParamModes: { deep: true, handler() { if (this.isMetaFormat && !this.isCarousel) this.syncMetaTemplateParams(); } },
        carouselCardParams: { deep: true, handler() { if (this.isMetaFormat && this.isCarousel) this.syncMetaTemplateParams(); } },
        carouselCardParamModes: { deep: true, handler() { if (this.isMetaFormat && this.isCarousel) this.syncMetaTemplateParams(); } },
        carouselCardUseUrl: { deep: true, handler() { if (this.isMetaFormat && this.isCarousel) this.syncMetaTemplateParams(); } },
        mediaType: {
            deep: true,
            handler() {
                if (this.mediaType === "static" && this.clone.asset?.externalUrl) {
                    this.clone.asset = null;
                }
                if (this.isMetaFormat && !this.isCarousel && this.hasMediaHeader) {
                    this.syncMetaTemplateParams();
                }
            },
        },
        externalUrl: {
            deep: true,
            handler() {
                if (this.mediaType === "dynamic") {
                    this.clone.asset = {
                        externalUrl: this.externalUrl,
                    };
                }
                if (this.isMetaFormat && !this.isCarousel && this.hasMediaHeader) {
                    this.syncMetaTemplateParams();
                }
            },
        },
        clone: {
            deep: true,
            handler(newValue) {
                var payload = _.cloneDeep(newValue);
                if (payload.templateParamsByTemplateId) delete payload.templateParamsByTemplateId;
                this.$emit("input", payload);
            },
        },
        "clone.channelId": {
            deep: true,
            handler() {
                this.syncMmliteSendDefault();
                this.getChannelTemplates();
            },
        },
        "clone.template": {
            handler(newT, oldT) {
                const newId = newT && newT._id;
                const oldId = oldT && oldT._id;
                if (newId !== oldId && this.selectedTemplateIsMarketing && this.channelMmliteOnboarded && this.isSupsisWabaChannel) {
                    this.$set(this.clone, "sendTemplateViaMmlite", true);
                }
            },
        },
        isMmliteSendChoiceAvailable: {
            immediate: true,
            handler() {
                this.syncMmliteSendDefault();
            },
        },
        businessChannels: {
            deep: true,
            handler() {
                this.syncMmliteSendDefault();
            },
        },
    },
};
</script>

<style lang="scss">
.template-preview-modal {
    .custom-modal-header {
        display: none !important;
    }

    .ant-modal-content {
        background: transparent !important;
        box-shadow: none;
    }

    .ant-modal-body {
        background: transparent !important;
    }

    .custom-modal-body {
        background: transparent !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.block-editor.send-waba-template-message {
    padding: 20px;
    display: flex;
    align-items: flex-start;
    gap: 20px;

    .ant-spin-nested-loading {
        width: 100%;
    }

    .ant-spin-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }

    .mmlite-block-not-onboarded {
        color: #5a5f72;
        line-height: 1.45;
        font-size: 13px;
    }

    .wpa-variables {
        margin-top: 15px;
    }

    .image-picker {
        margin-top: 15px;

        .input-warn {
            background: #fff6e6;
            padding: 20px;

            .list-item {
                padding-left: 15px;
            }
        }

        .media-preview {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .media-preview-content {
                display: flex;
                align-items: center;
                gap: 10px;

                .media-preview-name {
                    font-weight: bold;
                }

                .media-image img {
                    height: 100px;
                }
            }

            .media-preview-delete {
                background: red;
                padding: 5px;
                border-radius: 100%;
                color: white;
                line-height: 0;
            }
        }

        .media-drag {
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 10px;
            border: 1px solid var(--color-border-default);
            padding: 40px;
            cursor: pointer;
            position: relative;

            .input {
                width: 100%;
                height: 100%;

                input {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                }
            }

            .material-icons {
                font-size: 28px;
            }

            .content {
                font-size: 18px;
                font-weight: bold;
            }
        }
    }

    .classic-new-select {
        width: 100%;
        font-weight: bold;

        [role="combobox"] {
            padding: 4px;
            border: none !important;
            border-radius: 4px !important;
            background-color: #f1f1f1 !important;
        }
    }

    .meta-template-config {
        margin-top: 12px;

        .config-layout {
            display: flex;
            gap: 24px;
            align-items: flex-start;

            .config-area {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 1px;
                background: #f5f5f5;
                border-radius: 8px;
                overflow: hidden;
            }

            .preview-area {
                min-width: 300px;
                max-width: 300px;
                flex-shrink: 0;
                .whatsapp-message-preview {
                    width: 100%;
                }
            }
        }

        .tabs-container {
            border-bottom: 1px solid #e8e8e8;
            background: #fff;

            .tabs-header {
                display: flex;
                gap: 0;
                overflow-x: auto;

                .tab-item {
                    padding: 12px 16px;
                    font-size: 13px;
                    font-weight: 500;
                    color: #595959;
                    cursor: pointer;
                    border-bottom: 2px solid transparent;
                    transition: all 0.2s;
                    white-space: nowrap;
                    flex-shrink: 0;

                    &:hover {
                        color: #1677ff;
                    }

                    &.active {
                        color: #1677ff;
                        border-bottom-color: #1677ff;
                    }
                }
            }
        }

        .meta-block {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            display: flex;
            gap: 20px;
            background: #fff;
            flex-wrap: wrap;

            .meta-item {
                display: flex;
                flex-direction: column;
                gap: 4px;

                .meta-label {
                    font-size: 11px;
                    font-weight: 500;
                    text-transform: uppercase;
                    letter-spacing: 0.3px;
                    color: #8c8c8c;
                }

                .meta-value {
                    font-size: 13px;
                    font-weight: 500;
                    color: #262626;

                    &.meta-tag {
                        display: inline-block;
                        background: #e6f4ff;
                        color: #0958d9;
                        padding: 2px 8px;
                        font-size: 11px;
                        font-weight: 600;
                    }
                }
            }
        }

        .config-block {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            background: #fff;
            margin-bottom: 1px;

            .block-header {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 12px;

                .block-title {
                    font-size: 13px;
                    font-weight: 600;
                    color: #262626;
                }

                .block-hint {
                    font-size: 11px;
                    color: #8c8c8c;
                    background: #f0f0f0;
                    padding: 2px 8px;
                    border-radius: 4px;
                }
            }

            .media-source-selection {
                display: flex;
                gap: 8px;
                margin-bottom: 12px;
                padding: 4px;
                background: #fafafa;
                border-radius: 8px;

                .radio-option {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    cursor: pointer;
                    font-size: 13px;
                    color: #595959;
                    padding: 6px 12px;
                    border-radius: 6px;
                    transition: all 0.2s;

                    input[type="radio"] {
                        cursor: pointer;
                        width: 14px;
                        height: 14px;
                    }

                    span {
                        font-weight: 500;
                    }

                    &:hover {
                        color: #1677ff;
                        background: #f0f5ff;
                    }
                }
            }

            .media-url-input {
                margin-bottom: 8px;

                .editable-editor-wrapper .editable-editor {
                    background: #f5f5f5;
                }
            }

            .media-area {
                .media-uploaded {
                    position: relative;
                    background: #fafafa;
                    border: 1px solid #e8e8e8;
                    border-radius: 8px;
                    overflow: hidden;

                    img, video {
                        width: 100%;
                        max-height: 160px;
                        object-fit: cover;
                        display: block;
                    }

                    .doc-preview {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        padding: 20px 16px;
                        background: linear-gradient(135deg, #f0f5ff 0%, #fafafa 100%);

                        .anticon {
                            font-size: 28px;
                            color: #1677ff;
                        }

                        span {
                            font-size: 13px;
                            font-weight: 500;
                            color: #262626;
                        }
                    }

                    .remove-media {
                        position: absolute;
                        top: 8px;
                        right: 8px;
                        width: 24px;
                        height: 24px;
                        background: rgba(0, 0, 0, 0.6);
                        border: none;
                        border-radius: 50%;
                        color: #fff;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all 0.2s;

                        &:hover {
                            background: rgba(255, 77, 79, 0.9);
                            transform: scale(1.1);
                        }

                        .anticon {
                            font-size: 12px;
                        }
                    }
                }

                .upload-area {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 6px;
                    padding: 24px 16px;
                    border: 2px dashed #d9d9d9;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: all 0.2s;
                    background: #fafafa;

                    &:hover {
                        border-color: #1677ff;
                        background: #f0f5ff;

                        .anticon {
                            color: #1677ff;
                            transform: scale(1.1);
                        }
                    }

                    input {
                        display: none;
                    }

                    .anticon {
                        font-size: 28px;
                        color: #8c8c8c;
                        transition: all 0.2s;
                    }

                    .upload-label {
                        font-size: 13px;
                        font-weight: 500;
                        color: #262626;
                    }

                    .upload-format {
                        font-size: 11px;
                        color: #8c8c8c;
                    }
                }
            }

            .params-list {
                display: flex;
                flex-direction: column;
                gap: 14px;

                .param-row {
                    .param-info {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        margin-bottom: 6px;

                        .param-idx {
                            font-size: 12px;
                            font-weight: 700;
                            color: #1677ff;
                            font-family: 'Monaco', 'Menlo', monospace;
                            background: #e6f4ff;
                            padding: 2px 6px;
                            border-radius: 4px;
                        }

                        .param-ctx {
                            font-size: 12px;
                            color: #8c8c8c;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }

                    .param-controls {
                        display: flex;
                        flex-direction: column;
                        gap: 6px;
                        width: 100%;

                        .editable-editor-wrapper .editable-editor {
                            background: #f5f5f5;
                        }

                        .param-mode-selection {
                            display: flex;
                            gap: 8px;
                            padding: 4px;
                            background: #fafafa;
                            border-radius: 6px;

                            .mode-option {
                                display: flex;
                                align-items: center;
                                gap: 6px;
                                cursor: pointer;
                                font-size: 12px;
                                color: #595959;
                                padding: 4px 10px;
                                border-radius: 4px;
                                transition: all 0.2s;

                                input[type="radio"] {
                                    cursor: pointer;
                                    width: 14px;
                                    height: 14px;
                                }

                                span {
                                    font-weight: 500;
                                }

                                &:hover {
                                    color: #1677ff;
                                    background: #f0f5ff;
                                }
                            }
                        }
                    }

                    .param-field {
                        width: 100%;
                        padding: 8px 12px;
                        border: 1px solid #d9d9d9;
                        border-radius: 6px;
                        font-size: 13px;
                        outline: none;
                        transition: all 0.2s;
                        background: #fff;
                        box-sizing: border-box;

                        &:hover {
                            border-color: #40a9ff;
                        }

                        &:focus {
                            border-color: #1677ff;
                            box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
                        }

                        &::placeholder {
                            color: #bfbfbf;
                        }
                    }
                }
            }
        }

        .ready-state {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px;
            background: #fff;

            .ready-icon {
                width: 48px;
                height: 48px;
                background: linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%);
                border: 2px solid #b7eb8f;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 16px;
                box-shadow: 0 4px 12px rgba(82, 196, 26, 0.15);

                .anticon {
                    font-size: 24px;
                    color: #52c41a;
                }
            }

            .ready-text {
                font-size: 14px;
                font-weight: 600;
                color: #262626;
            }

            .ready-hint {
                font-size: 12px;
                color: #8c8c8c;
                margin-top: 4px;
            }
        }
    }
}
</style>
